import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearLeftDoorInteriorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearLeftDoorInterior(props: RearLeftDoorInteriorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Left Door"
      width={318}
      height={72}
      viewBox="0 0 318 72"
      position={{bottom: -5, right: 321}}
    >
      <path
        d="M257 66C284 66 317 55 317 37C317 35 316.333 32.903 316 32.1045H287L206.928 32.3936L200.915 32.415L39 33L15 32.6953C15.3333 34.8086 15 40.7671 11 47.6953C7 54.6235 3.33333 62.8867 2 66H257Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M39 32.9998H15C15.3333 35.113 15 40.7671 11 47.6953C7 54.6235 3.33333 62.8868 2 66H257C284 66 317 55 317 37C317 35.2514 316.634 33.5887 315.937 32L39 32.9998Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M13 44.3913C120.201 43.1958 226.843 43.7192 316 42.3044"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224 56C238.937 56.0003 258.853 58 256.861 61C250.119 71.1562 231.966 71 224 71C216.034 71 197.881 71.1562 191.139 61C189.147 58 209.062 56.0003 224 56ZM207 62C208.766 64.2432 211.491 66 216 66H232C236.509 66 239.234 64.2432 241 62H207Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M256.862 61C250.119 71.1563 231.966 70.9999 224 70.9999C216.034 70.9999 197.881 71.1563 191.138 61C189.147 58 209.062 56.0003 224 56C238.937 56.0003 258.853 58 256.862 61Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M243 57C242.667 59.6667 240 66 232 66C224 66 224 66 224 66C224 66 224 66 216 66C208 66 205.333 59.6667 205 57"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M207 62H241"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M177 1C185.23 1 191.117 3.09208 195 6.16699V6H257C262 6 287 6 287 18H306C310 18 311 20 316 32L39 33H15V18H39C39 2.05673 42 1 51 1H177Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M39 18C39 2.05673 42 1 51 1H177C194 1 201 9.92766 201 18"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M195 6H257C262 6 287 6 287 18"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="7"
        height="7"
        rx="3.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 181 12.9999)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="3"
        height="8"
        rx="1.5"
        transform="matrix(-4.37114e-08 -1 -1 4.37114e-08 170 11)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        width="7"
        height="7"
        rx="3.5"
        transform="matrix(1 0 0 -1 49 29)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M15 18V33L39 32.9998L316 32C311 20 310 18 306 18H15Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
